/**
 * Fonction servant à récupérer si les utilisateurs ont accepté ou non la charte
 *
 * @param {Object[]} usersCharterSignedCount - Données du nombre d'utilisateurs par charte signée ou non
 * @param {boolean} usersCharterSignedCount[].charteSigned - Si l'utilisateur a accepté ou non la charte
 * @param {number} usersCharterSignedCount[].userCount - Nombre d'utilisateurs par charte signée ou non
 *
 * @returns {NivoPieChartData}  données formatées pour Nivo
 */
export function getChartSignedStatusData(usersCharterSignedCount) {
  /* Création d'un objet pour stocker le nombre d'utilisateurs par charte signée : {charte signée : nombre} */
  let chartSignedByNumbers = {};

  // Création de deux clés : charte validée / charte refusée
  chartSignedByNumbers["Validé"] = 0;
  chartSignedByNumbers["Refusé"] = 0;

  // Pour chaque utilisateur, on vérifie si il a accepté ou non la charte
  // et on incrémente la clé correspondante dans l'objet
  usersCharterSignedCount?.forEach((user) => {
    user.charteSigned
      ? (chartSignedByNumbers["Validé"] = user.userCount)
      : (chartSignedByNumbers["Refusé"] = user.userCount);
  });

  const chartData = [];

  Object.keys(chartSignedByNumbers).forEach((key) => {
    chartData.push({
      label: key,
      id: key,
      value: chartSignedByNumbers[key],
    });
  });

  return chartData;
}
